import React from 'react'
import './styles.scss'

/**
 * Shows a question mark icon 
 * when hovered over shows a tooltip message in a bubble.
 */
type Props = {
  message?: string
  placement?: 'top' | 'bottom'
}
const Tooltip: React.FC<Props> = ({ message, placement = 'bottom' }) => {
  if(!message) return null

  const placementClass = placement === 'top' ? 'question-bubble--top' : ''

  return (
    <div className={`question-bubble d-inline-flex ${placementClass}`.trim()}>
      ?
      <span className='tooltip-text bg-white'>{message}</span>
    </div>
  )
}

export default Tooltip